export type Authority =
  | "ROLE_ERP_ADMIN"
  | "ROLE_ERP_MANAGER"
  | "ROLE_ERP_IT_ADMIN"
  | "ROLE_INVENTORY_MANAGER"
  | "ROLE_ERP_DATA"
  | "ROLE_ERP_REFURB_VENDOR"
  | "ROLE_ERP_WARRANTY_VENDOR"
  | "ROLE_FRANCHISE_INVENTORY_MANAGER"
  | "ROLE_ERP_FRANCHISE_ADMIN";

export const getCurrentAuthority = (): Authority | null =>
  localStorage.getItem("authority") as Authority | null;

/** True if current role is in allowedRoles (whitelist). Omit = visible to all. */
export const hasRole = (allowedRoles?: Authority[]): boolean => {
  if (!allowedRoles?.length) return true;
  const authority = getCurrentAuthority();
  return !!authority && allowedRoles.includes(authority);
};

/** True if current role is in deniedRoles (blacklist). */
export const isRoleDenied = (deniedRoles?: Authority[]): boolean => {
  if (!deniedRoles?.length) return false;
  const authority = getCurrentAuthority();
  return !!authority && deniedRoles.includes(authority);
};